import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';

interface IRequestInterceptors<T = AxiosResponse> {
  responseInterceptor: (res: T) => T;
  requestInterceptor: (
    config: InternalAxiosRequestConfig
  ) => InternalAxiosRequestConfig;
}

interface IRequireFieldCheck {
  fields?: string[]; // 非空字段列表
  check?: (value: any) => boolean; // 自定义参数检查逻辑，检查通过则返回true
  return?: any; // 此字段代表模拟接口的返回值，不传则默认抛出异常
}

interface IRequestConfig<T = AxiosResponse> extends AxiosRequestConfig {
  interceptors?: IRequestInterceptors<T>;
  requireFieldCheck?: IRequireFieldCheck;
  /** Return the response body without unwrapping data or Data. */
  rawResponseData?: boolean;
}

export default class IAxios {
  instance: AxiosInstance;
  interceptors?: IRequestInterceptors;

  constructor(config: IRequestConfig) {
    this.instance = axios.create(config);
    this.interceptors = config.interceptors;

    // Use instance request interceptors
    this.instance.interceptors.request.use(
      this.interceptors?.requestInterceptor
    );

    // Use instance response interceptors
    this.instance.interceptors.response.use(
      this.interceptors?.responseInterceptor
    );
  }

  request<T>(iReqeuestConfig: IRequestConfig<T>): Promise<T> {
    const { data, params, requireFieldCheck } = iReqeuestConfig || {};
    // 校验必填字段
    if (requireFieldCheck) {
      // 合并 data 和 params，GET 请求参数在 params 中，POST 请求参数在 data 中
      const requestData = { ...params, ...data };
      let missingFields: string[] = [];
      if (requireFieldCheck.fields?.length) {
        missingFields = requireFieldCheck.fields.filter((field) => {
          const value = requestData?.[field];
          if (value === false || value === 0) {
            return false;
          }
          return !value; // 保留值缺少的字段，如undefined、null、""
        });
      }
      if (requireFieldCheck.check && !requireFieldCheck.check(requestData)) {
        missingFields.push('check func fail');
      }
      if (missingFields.length) {
        const errorMessage = `Missing required fields: ${missingFields.join(
          ', '
        )}`;
        console.error('Validation Error:', errorMessage);
        if (requireFieldCheck.return) {
          return Promise.resolve(requireFieldCheck.return);
        }
        return Promise.reject(new Error(errorMessage));
      }
    }
    return new Promise<T>((resolve, reject) => {
      this.instance
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .request<T, any>(iReqeuestConfig)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
